import React, { Suspense } from 'react'
import Loading from './Loading'
import ResultsTable from './Table'

const ResultsCard: React.FC = () => (
  <Suspense fallback={<Loading />}>
    <ResultsTable />
  </Suspense>
)

export default ResultsCard
